import React from "react";
import { Box, Grid2 } from "@mui/material";
import styles from "./MyLearnings.module.scss";
import CustomSkeleton from "../../../components/custom-skeleton/CustomSkeleton";

const MyLearningCustomSkeleton: React.FC = () => {
  return (
    <Box zIndex={3} margin={"auto"} maxWidth={"996px"}>
      <Box className={styles.categorySection}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          mx={2}
        >
          <CustomSkeleton
            variant="rectangular"
            width="20%"
            height={40}
            className={styles.buttonSkeleton}
          />
        </Box>

        <Grid2 container spacing={3}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Grid2 key={idx} size={{ xs: 12, sm: 12, md: 4 }}>
              <CustomSkeleton
                variant="rectangular"
                width="100%"
                sx={{
                  borderRadius: "16px",
                  height: {
                    xs: 150,
                    md: 250,
                  },
                }}
              />
            </Grid2>
          ))}
        </Grid2>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          my={3}
        >
          <CustomSkeleton
            variant="rectangular"
            width="20%"
            height={40}
            className={styles.buttonSkeleton}
          />
        </Box>

        <Grid2 container spacing={3}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Grid2 key={idx} size={{ xs: 12, sm: 12, md: 4 }}>
              <CustomSkeleton
                variant="rectangular"
                width="100%"
                sx={{
                  borderRadius: "16px",
                  height: {
                    xs: 150,
                    md: 250,
                  },
                }}
              />
            </Grid2>
          ))}
        </Grid2>
      </Box>
    </Box>
  );
};

export default MyLearningCustomSkeleton;

